import {getSlicedTopSubNavigationItems} from '../../../helper/sub-navigation-helper.js';
import {NewFlag} from './NewFlag.jsx';
import Landmark from '@core/scripts/components/landmark-adapter';

export const FourthLevelNavigation = ({thirdLevelItem, texts}) => {
    const slicedTopSubNavigationItems = getSlicedTopSubNavigationItems(thirdLevelItem);

    const handleClick = (id) => {
        const naviLmValue = `hn\\${id}\\\\`;
        Landmark.sendUserInterfaceLandmark({navi: naviLmValue});
    };

    return (
        <div className='navigation__level -level:fourth'>
            {slicedTopSubNavigationItems
                .filter((item) => !item.overviewItem)
                .map((item) => {
                    const titleColor = item.fontColor || 'primary';
                    return (
                            <div className={`navigation__item -level:fourth ${item.active ? 'is-active' : ''}`}
                                 key={item.id}>
                                <a
                                    className={`navigation__item-label navigation__item-link text-clr-${titleColor}`}
                                    href={item.url}
                                    onClick={() => handleClick(item.id)}
                                >
                                    {item.hasNewFlag && <NewFlag />}
                                    <p>
                                        {item.title}
                                    </p>
                                </a>
                            </div>
                        )
                    }
                )}
            {thirdLevelItem.maximumTopNaviSubItemCount > 0 && (
                <a className='navigation__item navigation__item--more-shops' href={thirdLevelItem.url}>
                    {texts.more_shops_label}
                </a>
            )}
        </div>
    );
};
